import { NgModule, InjectionToken } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AuthGuard } from './_guards/auth.guard';

import { HomeComponent } from './home/home.component';
import { MainShowComponent } from './main/components/main-show/main-show.component';
import { MasterShowComponent } from './main/components/master-show/master-show.component';
import { AutoOptiShowComponent } from './main/components/auto-opti-show/auto-opti-show.component';
import { DocumentShowComponent } from './main/components/document-show/document-show.component';
import { UserShellComponent} from './user/containers/user-shell/user-shell.component';
import { AgentShellComponent } from './agent/containers/agent-shell/agent-shell.component';
import { AgentEditShellComponent } from './agent/containers/agent-edit-shell/agent-edit-shell.component';
import { EaselShellComponent } from './maestros/easel/containers/easel-shell/easel-shell.component';

import { CustomersShellComponent } from './customers/containers/customers-shell/customers-shell.component';
import { CustomersEditShellComponent } from './customers/containers/customers-edit-shell/customers-edit-shell.component';
import { ParameterShellComponent } from './parameter/containers/parameter-shell/parameter-shell.component';
import { TrackingShellComponent } from './tracking/containers/tracking-shell/tracking-shell.component';
import { TrackingEditShellComponent } from './tracking/containers/tracking-edit-shell/tracking-edit-shell.component';
import { CuttingTableShellComponent } from './maestros/cutting_table/containers/cutting_table-shell/cutting_table-shell.component';
import { BendingMachineShellComponent } from './maestros/bending_machine/containers/bending-machine-shell/bending-machine-shell.component';
import { LabelEditorShellComponent } from './maestros/label_editor/containers/label-editor-shell/label-editor-shell.component';
import { WorkstepShellComponent } from './maestros/workstep/containers/workstep-shell/workstep-shell.component';
import { ReasonShellComponent } from './maestros/reason/containers/reason-shell/reason-shell.component';
import { OptiShellComponent } from './opti/containers/opti-shell/opti-shell.component';
import { OptiEditShellComponent } from './opti/containers/opti-edit-shell/opti-edit-shell.component';
import { OptiProdShellComponent } from './opti/containers/opti-prod-shell/opti-prod-shell.component';
import { ProductionPlanningComponent } from './opti/components/production-planning/production-planning.component';

import { NotFoundComponent } from './main/components/not-found/not-found.component';
import { HelpCenterComponent } from './help/help-center.component';

// Turomas componentes
import { FileEditShellComponent } from './file/containers/file-edit-shell/file-edit-shell.component';
import { FileShellComponent } from './file/containers/file-shell/file-shell.component';



const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'main',
    component: MainShowComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'help',
    component: HelpCenterComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'master',
    component: MasterShowComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'auto-opti-lote',
    component: AutoOptiShowComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'parameter',
    component: ParameterShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'agent',
    component: AgentShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'agent-edit',
    component: AgentEditShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'easel',
    component: EaselShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'easel-edit',
    redirectTo: 'easel',
    pathMatch: 'full'
  },
  {
    path: 'customers',
    component: CustomersShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'customers-edit',
    component: CustomersEditShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'tracking',
    component: TrackingShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'tracking-edit',
    component: TrackingEditShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cutting_table',
    component: CuttingTableShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cutting_table-edit',
    redirectTo: 'cutting_table',
    pathMatch: 'full'
  },
  {
    path: 'bending_machine',
    component: BendingMachineShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'reason',
    component: ReasonShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'reason-edit',
    redirectTo: 'reason',
    pathMatch: 'full'
  },
  {
    path: 'label_editor',
    component: LabelEditorShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'workstep',
    component: WorkstepShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'workstep-edit',
    redirectTo: 'workstep',
    pathMatch: 'full'
  },
  {
    path: 'opti_list',
    component: OptiShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'opti_list/:rf',
    component: OptiShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'opti_edit',
    component: OptiEditShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'opti_prod',
    component: OptiProdShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'opti_prod/:rf',
    component: OptiProdShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'production_planning',
    component: ProductionPlanningComponent,
    canActivate: [AuthGuard]
  },

  // TUROMAS rutas --------------------
  {
    path: 'file-edit',
    component: FileEditShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'file-list',
    component: FileShellComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'file-list/:opt',
    component: FileShellComponent,
    canActivate: [AuthGuard]
  },
  // Fin TUROMAS rutas ----------------

  {
    path: 'document',
    component: DocumentShowComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'document/:ff/:rf/:rb', // Para usar tres parámetros de entrada (ruta fichero, refresco, ruta vuelta/back).
    component: DocumentShowComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    component: UserShellComponent
  },
  {
    path: 'externalRedirect',
    resolve: {
        url: externalUrlProvider,
    },
    // We need a component here because we cannot define the route otherwise
    component: NotFoundComponent,
    canActivate: [externalUrlProvider]
  },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  providers: [
      {
        // Para pasar por aquí cuando se usa "route.navigate" con el path "externalRedirect".
        // Coge el parámetro "externalUrl" que contiene una URL externa y lo abre en una ventana.
          provide: externalUrlProvider,
          useValue: (route: ActivatedRouteSnapshot) => {
              const externalUrl = route.paramMap.get('externalUrl');

              console.log('-> ** -> externalUrl:');
              console.log(externalUrl);

              // window.open(externalUrl, '_self');
              window.open(externalUrl, '_blank');
          },
      },
      // IMPORTANTE: Evita el problema de recarga de página en servidor.
      { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  imports: [RouterModule.forRoot(routes)],
  // NOTA: si quisiéramos que apareciera /# en la dirección del navegador.
  // imports: [RouterModule.forRoot(routes, {useHash : true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
